import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DevIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "8",
                fill: "#00C875"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.0823 18.6854C20.5179 18.735 18.4564 20.8272 18.4564 23.4035C18.4564 25.9776 20.5142 28.0683 23.0754 28.1215V28.1265H36.7881V28.1226H37.3272V28.1318C37.6002 28.1415 37.8758 28.2482 38.1023 28.4736L40.3903 30.7488C40.8499 31.2059 40.8499 31.9497 40.3903 32.4069L38.1023 34.6821C37.8288 34.9541 37.4838 35.0534 37.1581 35.0175H23.1755C23.1434 35.0175 23.1113 35.0174 23.0793 35.0171L23.0184 35.0174L22.9874 35.0175H22.1198C15.174 34.1911 12.5243 28.596 11.9373 26.2484L11.9138 26.2543C11.6837 25.3422 11.5615 24.3872 11.5615 23.4035C11.5615 17.1265 16.5381 12.0145 22.7619 11.7968C22.8364 11.792 22.9116 11.7896 22.9874 11.7896C23.0195 11.7896 23.0516 11.7897 23.0837 11.7899C23.1142 11.7897 23.1448 11.7896 23.1755 11.7896C23.2504 11.7896 23.3248 11.792 23.3986 11.7967C29.6235 12.0132 34.6014 17.1257 34.6014 23.4035C34.6014 24.3701 34.4833 25.309 34.261 26.2068H26.7847C27.364 25.4231 27.7064 24.4535 27.7064 23.4035C27.7064 20.8277 25.6459 18.7359 23.0823 18.6854ZM10.5349 28.1225H10.1848C8.28079 28.1225 6.7373 29.666 6.7373 31.57C6.7373 33.474 8.28079 35.0175 10.1848 35.0175H16.2326C13.0984 33.1003 11.3599 30.2109 10.5349 28.1225Z",
                fill: "white"
            })
        ]
    });
